function formFileInit() {
	//отправка формы обратной связи из Контакты
	$(".form").on("click", "#submit_btn3", function(e) {
		if (window.yaCounter23103697) yaCounter23103697.reachGoal("enrollonline:contacts");
		
		var validateOpts = $.extend({}, mainValidateOpts);

		validateOpts.submitHandler = function(form, e) {
			e.preventDefault();

			$("#secur_chk2").val("Y");
			// var fields = $("#want_form3").serialize();


			// $(".form").load('/modal_includes/contacts_request.php',fields,function(){
			//     activate_phone();
			// });

			$(".form").ajaxSubmit({
				success: function(response) {
					activate_phone();
				}
			});

			return false;
		}

		$(this).closest('.form').find('#want_form3').validate(validateOpts);
	});
}


